import { AI_MODEL } from "@/store/zustand/aiActionStore";
import { ICONS } from "@/components/Core/Icons";

export interface ModelConfig {
  icon: (typeof ICONS)[keyof typeof ICONS];
  label: string;
  tooltip?: string;
}

export const MODEL_CONFIG_MAP: Partial<Record<AI_MODEL, ModelConfig>> = {
  [AI_MODEL.GEMINI_2_0_FLASH]: { icon: ICONS.GEMINI, label: "Gemini 2.0" },
  [AI_MODEL.CLAUDE_4_6_OPUS]: {
    icon: ICONS.CLAUDE,
    label: "Opus 4.6",
    tooltip:
      "Most expensive but most capable. Best for complex problems requiring deep reasoning.",
  },
  [AI_MODEL.CLAUDE_4_6_SONNET]: {
    icon: ICONS.CLAUDE,
    label: "Sonnet 4.6",
    tooltip:
      "Smartest model for complex agents and coding. Best all-around intelligence.",
  },
  [AI_MODEL.CLAUDE_4_5_HAIKU]: {
    icon: ICONS.CLAUDE,
    label: "Haiku 4.5",
    tooltip: "Fastest and cheapest. Great for rapid development.",
  },
  [AI_MODEL.GEMINI_3_1_PRO]: {
    icon: ICONS.GEMINI,
    label: "Gemini 3.1 Pro",
    tooltip:
      "Most powerful agentic and coding model with state-of-the-art reasoning. Best for complex multimodal understanding.",
  },

  [AI_MODEL.GPT_5]: {
    icon: ICONS.OPENAI,
    label: "GPT 5",
    tooltip:
      "OpenAI's flagship with adaptive reasoning. Cost-effective with reduced hallucinations. Strong all-rounder.",
  },
  [AI_MODEL.GPT_52]: {
    icon: ICONS.OPENAI,
    label: "GPT 5.2",
    tooltip:
      "Most consistent and predictable outputs. Adaptive reasoning with expanded context handling. Better customization control for tone and style.",
  },
  [AI_MODEL.GPT_53_CODEX]: {
    icon: ICONS.OPENAI,
    label: "GPT 5.3 Codex",
    tooltip:
      "Optimized for code generation. Fast and efficient for development tasks.",
  },
  [AI_MODEL.AUTO]: {
    icon: ICONS.ZAP,
    label: "Auto",
    tooltip: "Balance quality, speed and cost. Recommended for most use cases.",
  },
};

export const CLAUDE_AGENT_MODELS = [
  AI_MODEL.CLAUDE_4_6_OPUS,
  AI_MODEL.CLAUDE_4_6_SONNET,
  AI_MODEL.CLAUDE_4_5_HAIKU,
];
